import { useState, useEffect } from 'react';
import API from '../../../data/api';

/** Loads the SOS analysis of a tag while the modal is open. */
export function useSOSAnalysisController({ visible, tag }) {
    const [loading, setLoading] = useState(false);
    const [analysis, setAnalysis] = useState(null);

    const api = API.Instance();

    useEffect(() => {
        if (visible && tag) {
            fetchAnalysis();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, tag]);

    const fetchAnalysis = async () => {
        setLoading(true);
        try {
            const response = await api.requestSOSAnalysis(tag._id);
            setAnalysis(response);
        } catch (error) {
            console.error('Error fetching SOS analysis:', error);
        } finally {
            setLoading(false);
        }
    };

    return { loading, analysis };
}

/** Category rows (expected vs actual) for a store's expanded row. */
export function buildSOSRows(record) {
    return record.expectedSOS.map((expected) => ({
        category: expected.category,
        expected: expected.targetPercentage,
        actual: record.actualSOS[expected.category] || 0,
        deviation: Math.abs((record.actualSOS[expected.category] || 0) - expected.targetPercentage)
    }));
}
